import React from 'react';
import { Alert } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function ServiceCapacityNotice({ children, action }) {
  return <Alert severity="warning" role="status" icon={<InfoOutlinedIcon fontSize="inherit" />} action={action}
    sx={{ bgcolor: '#fff8e6', color: '#59451c', border: '1px solid #e8d59e', fontSize: 13,
      '& .MuiAlert-icon': { color: '#87671e' } }}>
    {children}
  </Alert>;
}
